module.exports = __webpack_public_path__ + "static/axiforma-medium-webfont-f351e85c4c4f75ad390efa2052a007f4.woff2";